.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.modality {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.legend {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--tuna-spacing-2);
}

.control {
  min-width: 6rem;
}
